module.exports = __webpack_public_path__ + "img/robotics.22bf1641.png";